import React, { useState, useEffect, useContext, useCallback } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { MdOutlineFileUpload } from 'react-icons/md';
import { BsDot } from 'react-icons/bs';
import { ObjModal } from '../../../../contexts';
import { useDropzone } from 'react-dropzone';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { createFile, removeFile } from '../../../../common/api';
import { toast } from 'react-toastify';
import { storeMedia, createId, getMimeTypeFromExtension } from '../../../../common/utils';

const Files = ( { aid, uid } ) => {
    const { obj, objType, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( true );

    const onDrop = useCallback( acceptedFiles => {
        for ( let i = 0; i < acceptedFiles.length; i++ ) {
            const f = acceptedFiles[i];
            const reader = new FileReader();
            
            reader.onabort = () => {
                toast.success( `The upload process on ${f.path} has been aborted`, { theme: 'dark' } );
            }
            reader.onerror = () => {
                toast.success( `There's been an error while uploading ${f.path}`, { theme: 'dark' } );
            }
            reader.onload = async () => {
                const b = new Blob( [ reader.result ] );
                const ext = f.name.split( '.' )[1];
                let n = createId( 'file' );
                if ( ext ) {
                    n += '.' + ext;
                }
                
                const name = await storeMedia( obj.details.aid, uid, n, b, getMimeTypeFromExtension( ext ) );
                
                let cid;
                let lid;

                if ( objType === 'contact' ) {
                    cid = obj.details.cid;
                } else if ( objType === 'loan' ) {
                    lid = obj.details.lid;
                    const c = obj.borrowers?.find( f => f.label === 'Primary' );
                    if ( c ) {
                        cid = c.cid;
                    }
                }

                let file = {
                    mediaUrl: name,
                    name: f.name
                }
                if ( cid ) {
                    file['cid'] = cid;
                }
                if ( lid ) {
                    file['lid'] = lid;
                }

                await createFile( obj.details.aid, uid, file );

                toast.success( `Successfully uploaded ${f.name}`, { theme: 'dark' } );
                console.log( 'uploaded: ', name );
            }
            reader.readAsArrayBuffer( f );
        }
    }, [ uid, obj, objType ] );

    const { getRootProps, getInputProps, isDragActive } = useDropzone( { onDrop } );

    // useEffect( () => {
    //     setExpanded( obj.files.length > 0 );
    // }, [ obj.files ] );

    const trash = async ( faid, fid ) => {
        let removed = await removeFile( faid, uid, fid );
        if ( removed.length ) {
            toast.success( 'The file has been deleted', { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'gift':
                // setModal( <AddGift close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Files ({obj.files.length})</Typography></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <Row>
                        <Col className='p-2 text-center' { ...getRootProps() } style={ { color: 'var( --tf-blue )', fontWeight: 600, border: '1px dotted var( --tf-blue )' } }>
                            <input { ...getInputProps() } />
                            <Row><Col>Drop Files to Upload or <Button variant='outline-primary' size='sm'>Select Files</Button></Col></Row>
                        </Col>
                    </Row>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '400px' } }>
                    { obj.files.map( ( f, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row className='align-items-center'>
                                {/* <Col xs='auto' className='tf-sidebar-obj-value'>
                                    {f.name}
                                </Col> */}
                                <Col>
                                    <Row>
                                        <Col xs='auto' className='p-1 ps-3 pb-0'>
                                            <a href={`https://tf-media.s3.amazonaws.com/${obj.details.aid}/${f.mediaUrl}`} target="_blank" rel="noreferrer">{f.name}</a>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col xs='auto' className='p-1 ps-3 pt-0'>
                                            { f.createdBy }
                                        </Col>
                                    </Row> */}
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( f.aid, f.fid ) } /></Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Files );